import React from "react"

const OwnerCalendarPage = React.lazy(
    () => import("../pages/external/OwnerCalendar")
)

const OwnerLoginPage = React.lazy(() => import("../pages/external/OwnerLogin"))

export const OwnerCalendarRoutes = () => {
    return <OwnerCalendarPage />
}

export const OwnerLoginRoutes = () => {
    return <OwnerLoginPage />
}
